import { render, staticRenderFns } from "./ServicesReservationTreatmentPlanFloatBtns.vue?vue&type=template&id=64bd0b21&"
import script from "./ServicesReservationTreatmentPlanFloatBtns.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationTreatmentPlanFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports